<template>
  <q-page class="index-page q-my-xl">
    <home-slider v-if="false" class="q-mb-lg" />
    <earrings1 />
    <web-widget :name="widget.widget" :widget="widget" :key="widget.widget" v-for="widget in mainContent" />
  </q-page>
</template>

<script lang="ts">
import { PageStore } from 'stores/Page/Page.ts';
import { defineComponent } from 'vue';
import { useMeta } from 'quasar';
import { storeToRefs } from 'pinia';
import HomeSlider from 'components/Home/HomeSlider.vue';
import WebWidget from 'components/Widget/WebWidget.vue';
import Earrings1 from 'components/Campaigns/Contents/Earrings1.vue';

export default defineComponent({
  name: 'IndexPage',
  components: { Earrings1, WebWidget, HomeSlider },

  setup() {
    const pageStore = PageStore();
    const { head, content } = storeToRefs(pageStore);

    useMeta({
      titleTemplate: (title) => `${title} | ${head.value.title.slogan}`,
    });

    return {
      content,
      mainContent: content.value.site_main_index,
    };
  },
});
</script>

<style>
section:nth-child(2) {
  background: linear-gradient(90deg, #dbd1ea5e, transparent);
  padding: 2rem 0;
}

.index-page section .col-lg-3 {
  margin-bottom: 1rem;
}
</style>
